
document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.rs-reveal');
  if (!items.length) return;

  if (!('IntersectionObserver' in window)) {
    items.forEach(function (item) { item.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.16,
    rootMargin: '0px 0px -8% 0px'
  });

  items.forEach(function (item, index) {
    item.style.transitionDelay = Math.min(index * 70, 280) + 'ms';
    observer.observe(item);
  });
});


/* HOMEPAGE INTERACTION ONLY */
document.addEventListener('DOMContentLoaded', function () {
  var homeHero = document.querySelector('.rs-home-hero');
  if (!homeHero) return;

  document.body.classList.add('rs-home-motion-active');

  var revealSelectors = [
    '.rs-home-hero .rs4-hero__copy',
    '.rs-home-hero .rs4-hero__proof-wrap--premium',
    '.rs4-transformations--wide .rs4-head',
    '.rs4-transformations--wide .rs-home-result-card',
    '.rs-home-premium-section .rs4-head',
    '.rs-home-premium-section .rs4-cards > div',
    '.rs4-two--homefor > div',
    '.rs4-bullets--homefor > p',
    '.rs13-process-home .rs4-head',
    '.rs13-journey-grid > article',
    '.rs4-reviews .rs4-head',
    '.rs4-yotpo-shell--featured',
    '.rs13-about-support .rs13-rudolf-photo',
    '.rs13-about-support .rs4-about__copy',
    '.rs13-support-list--home > span',
    '.rs4-faq--home .rs4-head',
    '.rs4-faq--home > details',
    '.rs4-apply > div',
    '.rs4-form'
  ];

  var revealItems = [];
  revealSelectors.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (element) {
      if (revealItems.indexOf(element) === -1) revealItems.push(element);
    });
  });

  revealItems.forEach(function (element, index) {
    element.classList.add('rs-home-motion-reveal');
    element.style.setProperty('--rs-home-delay', Math.min((index % 4) * 75, 225) + 'ms');
  });

  if (!('IntersectionObserver' in window)) {
    revealItems.forEach(function (element) { element.classList.add('is-visible'); });
  } else {
    var homeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          homeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    revealItems.forEach(function (element) { homeObserver.observe(element); });
  }

  if (window.matchMedia('(pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.rs-home-result-card').forEach(function (card) {
      card.addEventListener('pointermove', function (event) {
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--rs-tilt-x', (-y * 1.2) + 'deg');
        card.style.setProperty('--rs-tilt-y', (x * 1.2) + 'deg');
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--rs-tilt-x', '0deg');
        card.style.setProperty('--rs-tilt-y', '0deg');
      });
    });
  }
});


/* HOMEPAGE PREMIUM MOTION ENHANCEMENT ONLY */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('.rs-home-hero')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var finePointer = window.matchMedia('(pointer:fine)').matches;

  /* Alternate reveal direction without changing layout. */
  var directionalGroups = [
    '.rs-home-result-card',
    '.rs4-cards > div',
    '.rs4-bullets--homefor > p',
    '.rs13-journey-grid > article',
    '.rs13-support-list--home > span',
    '.rs4-faq--home > details'
  ];
  directionalGroups.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (item, index) {
      item.style.setProperty('--rs-home-enter-x', (index % 2 === 0 ? '-18px' : '18px'));
    });
  });

  if (finePointer) {
    /* Gentle premium tilt for interactive cards. */
    var tiltItems = document.querySelectorAll([
      '.rs-home-proof-stat',
      '.rs-home-result-card',
      '.rs4-cards > div',
      '.rs13-journey-grid > article',
      '.rs4-bullets--homefor > p'
    ].join(','));

    tiltItems.forEach(function (item) {
      item.addEventListener('pointermove', function (event) {
        var rect = item.getBoundingClientRect();
        var px = (event.clientX - rect.left) / rect.width;
        var py = (event.clientY - rect.top) / rect.height;
        item.style.setProperty('--rs-home-tilt-x', ((0.5 - py) * 2.2) + 'deg');
        item.style.setProperty('--rs-home-tilt-y', ((px - 0.5) * 2.2) + 'deg');
        item.style.setProperty('--rs-home-glow-x', (px * 100) + '%');
        item.style.setProperty('--rs-home-glow-y', (py * 100) + '%');
      });
      item.addEventListener('pointerleave', function () {
        item.style.setProperty('--rs-home-tilt-x', '0deg');
        item.style.setProperty('--rs-home-tilt-y', '0deg');
      });
    });

    /* Magnetic button movement remains inside the button footprint. */
    document.querySelectorAll('.rs-home-hero .rs4-btn, .rs4-transformations--wide .rs4-btn, .rs-home-premium-section .rs4-btn, .rs13-about-support .rs4-btn, .rs4-apply-wrap .rs4-btn').forEach(function (button) {
      button.addEventListener('pointermove', function (event) {
        var rect = button.getBoundingClientRect();
        var x = event.clientX - rect.left - rect.width / 2;
        var y = event.clientY - rect.top - rect.height / 2;
        button.style.setProperty('--rs-home-button-x', (x * 0.08) + 'px');
        button.style.setProperty('--rs-home-button-y', (y * 0.12) + 'px');
      });
      button.addEventListener('pointerleave', function () {
        button.style.setProperty('--rs-home-button-x', '0px');
        button.style.setProperty('--rs-home-button-y', '0px');
      });
    });
  }

  /* Very subtle hero parallax, homepage only. */
  var heroVisual = document.querySelector('.rs-home-hero .rs4-hero__proof-wrap--premium');
  if (heroVisual) {
    var ticking = false;
    function updateHeroParallax() {
      var rect = heroVisual.getBoundingClientRect();
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var progress = Math.max(-1, Math.min(1, (viewport * 0.5 - (rect.top + rect.height * 0.5)) / viewport));
      heroVisual.style.setProperty('--rs-home-parallax-y', (progress * 7).toFixed(2) + 'px');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateHeroParallax);
      }
    }, { passive: true });
    updateHeroParallax();
  }
});
